import { TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Producer } from "../types";
import BaseButton from "../../../main/components/BaseButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useContext, useEffect } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import DangerBaseButton from "../../../main/components/DangerBaseButton";

interface AddUGProducersProps {
  producers: Producer[];
  setProducers: React.Dispatch<React.SetStateAction<Producer[]>>;
}

const AddUGProducers: React.FC<AddUGProducersProps> = ({
  producers,
  setProducers,
}) => {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;

  const handleInputChange =
    (index: number, property: keyof Producer) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // Update the state for the specified producer and property
      setProducers((prevProducers) =>
        prevProducers.map((producer, i) =>
          i === index ? { ...producer, [property]: e.target.value } : producer
        )
      );
    };

  const handleAddProducer = () => {
    // Add a new producer with initial values
    const newProducer: Producer = {
      contactPhone: "",
      contactEmail: "",
      portalAccessLink: "",
      portalAccessUsername: "",
      portalAccessPassword: "",
    };

    // Update the state to include the new producer
    setProducers((prevProducers) => [...prevProducers, newProducer]);
  };

  const handleRemoveProducer = (index: number) => {
    setProducers((prevProducers) => {
      const updatedProducers = [...prevProducers];
      updatedProducers.splice(index, 1);
      return updatedProducers;
    });
  };

  useEffect(() => {
    // Adiciona um novo produtor com valores iniciais
    const initialProducer: Producer = {
      contactPhone: "",
      contactEmail: "",
      portalAccessLink: "",
      portalAccessUsername: "",
      portalAccessPassword: "",
    };

    // Atualiza o estado para incluir o novo produtor
    setProducers([initialProducer]);
  }, []);

  return (
    <>
      {producers.map((producer, index) => (
        <Grid container key={index} spacing={2} sx={{ marginTop: "20px" }}>
          <Grid item xs={12} textAlign={"start"}>
            <Typography>{`Fabricante ${index + 1}`}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={`Telefone de Contato ${index + 1}`}
              value={producer.contactPhone || ""}
              onChange={handleInputChange(index, "contactPhone")}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={`Email de Contato ${index + 1}`}
              value={producer.contactEmail || ""}
              onChange={handleInputChange(index, "contactEmail")}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={`Link de Acesso ao Portal ${index + 1}`}
              value={producer.portalAccessLink}
              onChange={handleInputChange(index, "portalAccessLink")}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={`Usuário de Acesso ao Portal ${index + 1}`}
              value={producer.portalAccessUsername}
              onChange={handleInputChange(index, "portalAccessUsername")}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={`Senha de Acesso ao Portal ${index + 1}`}
              value={producer.portalAccessPassword}
              onChange={handleInputChange(index, "portalAccessPassword")}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          {index > 0 && (
            <Grid item xs={12} container alignItems="flex-start">
              <DangerBaseButton
                title="Remover "
                // title="Remover Fabricante"
                variant="contained"
                onClick={() => handleRemoveProducer(index)}
                startIcon={<DeleteIcon />}
              />
            </Grid>
          )}
        </Grid>
      ))}

      <Grid container key="addProducer" spacing={2}>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <BaseButton
            title="Adicionar Fabricante"
            onClick={handleAddProducer}
            startIcon={<AddIcon />}
            sx={{
              backGroundColor: primary,
              borderColor: primary,
              "& .MuiTypography-root": {
                color: primary,
              },
              "&:hover": {
                borderColor: primary,
                backgroundColor: primary,
                color: primary,
                "& .MuiTypography-root": {
                  color: "#FFFFFF",
                },
              },
              width: "180px",
              marginTop: "15px",
              height: "40px",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AddUGProducers;
